import ru from 'vuetify/src/locale/ru'

export default {
  ...ru,
  saving: 'Сохраняется...',
  savingQuestion: 'Вопрос {0}: Сохраняется...',
  savingResult: 'Результат {0}: Сохраняется...',
  savedSuccessfully: 'Успешно сохранено',
  voteGenerateStarted: 'Автоматическая накрутка запущена',
  savedQuestionSuccessfully: 'Вопрос {0}: Успешно сохранено',
  savedResultSuccessfully: 'Результат {0}: Успешно сохранено',
  errors: {
    requiredField: 'Поле обязательно для заполнения',
    positiveNumber: 'Укажите положительное число',
    positiveIntegerNumber: 'Укажите положительное целое число',
    invalidEmail: 'Введен не валидный Email',
    invalidUrl:
      'Некорректный url. Пример валидного url: https://example.com/path/',
    invalidErid: 'Внесите erid в формате 2RanymKJUZn',
    unsupportedFileType: 'Неподдерживаемый тип файла',
    audioFileTooLarge: 'Размер аудиофайла больше допустимого',
    audioFileUnreadable: 'Не удалось прочитать аудиофайл',
    audioDurationTooLong: 'Длительность аудио должна быть не более {0}',
    futureDateTime: 'Укажите дату и время в будущем',
    somethingWentWrong:
      'Произошла непредвиденная ошибка. Пожалуйста, обратитесь в службу технической поддержки.',
    requiredFieldForUploadedPhotos:
      'Поле "{0}" обязательно для загружаемых фото',
    requiredFieldForBackgroundImage:
      'Поле "{0}" для фонового изображения обязательно',
    questionError: 'Вопрос {0}: {1}',
    questionAnswerError: 'Вопрос {0} → Ответ {1}: {2}',
    resultActionError: 'Результат {0}: ошибка действия',
  },
}
